
import { isEqual } from 'lodash';
import { mixins, Options } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import MAddToCartPopup from '@/components/shopify/MAddToCartPopup.vue';
import MDiscountAvailable from '@/components/shopify/MDiscountAvailable.vue';
import MDiscountEligible from '@/components/shopify/MDiscountEligible.vue';
import MDiscountInactive from '@/components/shopify/MDiscountInactive.vue';
import MLoading from '@/components/shopify/MLoading.vue';
import MTokenExclusiveWarning from '@/components/shopify/MTokenExclusiveWarning.vue';
import { CAMPAIGN_CART_UPDATED } from '@/constants/events';
import CartWidgetMixin from '@/mixins/cartWidget';

@Options({
  components: {
    MAddToCartPopup,
    MLoading,
    MTokenExclusiveWarning,
    MDiscountAvailable,
    MDiscountEligible,
    MDiscountInactive
  }
})
export default class MAddToCart extends mixins(CartWidgetMixin) {
  popupIsOpen = false;
  htmlOverflowInitial: string | undefined;
  bodyOverflowInitial: string | undefined;
  show = false;
  rewardsFetched = false;
  eligibleRewards: any[] = [];
  hasDiscount = false;
  unrestricted = false;

  @Watch('state.eligibleRewards')
  eligibleRewardsWatcher(value: any, oldValue: any) {
    if (!isEqual(value, oldValue)) {
      this.updateTokens(value);
    }
  }

  @Watch('state.isUnrestricted')
  unrestrictedWatcher(_value: any, _oldValue: any) {
    this.unrestricted = this.state.isUnrestricted;
  }

  @Watch('getters.productHasCampaign')
  productHasCampaign(value: boolean) {
    let connectWidgetStyle: string;
    if (value) {
      connectWidgetStyle = 'block';
      this.show = true;
    } else {
      connectWidgetStyle = 'none';
      this.show = false;
    }
    for (const element of document.querySelectorAll("[data-widget='m-connect']")) {
      (element as any).style.display = connectWidgetStyle;
    }
  }

  get buttonCTA() {
    return this.state.isSoldOut ? 'Sold Out' : 'Add to cart';
  }

  get isSoldOut() {
    return this.state.isSoldOut;
  }

  async updateTokens(allEligibleRewards: any[]) {
    const eligibleRewards = [];
    this.hasDiscount = false;
    for (let i = 0; i < allEligibleRewards?.length; i++) {
      for (let j = 0; j < allEligibleRewards[i].rules.length; j++) {
        eligibleRewards.push({
          token: allEligibleRewards[i].token,
          campaignId: allEligibleRewards[i].rules[j].campaignId,
          reward: allEligibleRewards[i].rules[j].rule
        });
        if (
          allEligibleRewards[i].rules[j].rule.discountAmount ||
          allEligibleRewards[i].rules[j].rule.discountPercent
        ) {
          this.hasDiscount = true;
        }
      }
    }
    this.rewardsFetched = true;
    this.eligibleRewards = eligibleRewards;
  }

  async addToCartNormal() {
    // Add to client-side shopify cart
    let currentVariantId;

    if (!this.productIdOverride) {
      currentVariantId = this.state.ShopifyAPIClient.getCurrentVariantId();
      if (!currentVariantId) {
        const currentProduct = await this.state.ShopifyAPIClient.getCurrentProduct();
        currentVariantId = currentProduct.variants[0].id;
      }
    } else if (this.productIdOverride) {
      currentVariantId = this.productIdOverride;
    }
    const currentQuantity = this.state.ShopifyAPIClient.getCurrentQuantity();

    const resp = await this.state.ShopifyAPIClient.addToBrowserCart(
      currentVariantId,
      currentQuantity,
      this.cartIconSection,
      this.productProperties
    );
    if (resp && resp.sections && this.cartIconSection) {
      for (const cartIconSection of this.cartIconSection.split(',')) {
        const newCartIconBubble = resp.sections[cartIconSection];
        if (document.getElementById(cartIconSection) && newCartIconBubble) {
          document.getElementById(cartIconSection)!.innerHTML = newCartIconBubble;
        }
      }
    }
    // Dispatch cart updated event
    window.dispatchEvent(new CustomEvent(CAMPAIGN_CART_UPDATED));
  }

  openPopup(e: any) {
    e.preventDefault();
    this.htmlOverflowInitial = document.documentElement.style.overflowY;
    this.bodyOverflowInitial = document.body.style.overflowY;
    document.documentElement.style.overflowY = 'hidden !important';
    document.body.style.overflowY = 'hidden !important';
    this.popupIsOpen = true;
  }

  close() {
    document.documentElement.style.overflowY = this.htmlOverflowInitial!;
    document.body.style.overflowY = this.bodyOverflowInitial!;
    this.popupIsOpen = false;
  }

  get disabled() {
    return (
      (this.state && this.state.wrongChain) ||
      (!this.state && this.state.walletAddress) ||
      this.state?.isSoldOut
    );
  }

  get buttonText() {
    if (this.state && this.state.isSoldOut) {
      return 'Sold Out';
    }
    if (!this.state && this.state.walletAddress) {
      return this.connectWalletText ? this.connectWalletText : 'Connect Wallet to Claim';
    }
    return this.hasDiscount
      ? this.applyDiscountText
        ? this.applyDiscountText
        : 'Apply Discount'
      : this.addToCartText
      ? this.addToCartText
      : 'Add to cart';
  }
}
